import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-gray-300">
      <div className="mx-auto max-w-[1250px] py-1 px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="text-2xl font-bold text-white font-heading hoverable">
              TECHVEDA<span className="text-primary-500">.</span>
            </Link>
            <p className="mt-4 text-sm font-body">
              Building innovative web applications and digital solutions that transform ideas into reality.
            </p>
            <div className="mt-6 flex space-x-4">
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors hoverable"
                aria-label="GitHub"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.167 6.839 9.49.5.09.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.342-3.369-1.342-.454-1.155-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.268 2.75 1.026A9.578 9.578 0 0112 6.836c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.026 2.747-1.026.546 1.377.202 2.394.1 2.647.64.7 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.137 20.164 22 16.42 22 12c0-5.523-4.477-10-10-10z" />
                </svg>
              </a>
              <a
                href="https://in.pinterest.com/techvedainfo/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors hoverable"
                aria-label="Twitter"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.477 2 2 6.24 2 11.5c0 3.567 2.057 6.637 5.022 7.97-.07-.676-.132-1.716.028-2.456.145-.674.934-4.297.934-4.297s-.238-.475-.238-1.177c0-1.102.64-1.923 1.434-1.923.676 0 1 .507 1 1.114 0 .678-.432 1.693-.656 2.636-.186.788.394 1.43 1.167 1.43 1.4 0 2.476-1.475 2.476-3.6 0-1.878-1.35-3.19-3.278-3.19-2.233 0-3.544 1.675-3.544 3.406 0 .678.26 1.406.584 1.803a.236.236 0 01.054.225c-.06.248-.194.788-.22.897-.034.144-.115.175-.266.106-.994-.457-1.614-1.888-1.614-3.038 0-2.475 1.8-4.75 5.186-4.75 2.72 0 4.832 1.94 4.832 4.528 0 2.7-1.7 4.88-4.06 4.88-.793 0-1.54-.414-1.794-.902l-.487 1.854c-.175.675-.652 1.523-.97 2.04A10.03 10.03 0 0012 22c5.523 0 10-4.24 10-9.5S17.523 2 12 2z" />
                </svg>

              </a>
              <a
                href="https://dribbble.com/Techveda"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors hoverable"
                aria-label="LinkedIn"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.476 2 2 6.475 2 12s4.476 10 10 10 10-4.475 10-10S17.524 2 12 2zm6.938 6.734a7.91 7.91 0 0 1 1.385 4.255 14.83 14.83 0 0 0-5.289-.145 22.293 22.293 0 0 0-.936-2.195 23.12 23.12 0 0 0 4.84-1.915zm-2.125-2.197a7.93 7.93 0 0 1 2.404 2.413 21.36 21.36 0 0 1-4.586 1.82 30.44 30.44 0 0 0-2.036-3.49 8.018 8.018 0 0 1 4.218-.743zm-5.477.29a29.69 29.69 0 0 1 2.167 3.662 20.332 20.332 0 0 1-6.41.947 8.011 8.011 0 0 1 4.243-4.609zM4.97 9.624a7.966 7.966 0 0 1 1.903-3.118 22.26 22.26 0 0 1 5.035 1.032 31.76 31.76 0 0 1 1.946 3.337 18.364 18.364 0 0 0-7.787.473 7.897 7.897 0 0 1-1.097-1.724zm.264 6.898a7.91 7.91 0 0 1-.6-5.13 16.48 16.48 0 0 1 7.125-.45c.31.64.59 1.296.834 1.962a13.271 13.271 0 0 0-5.68 4.623 7.934 7.934 0 0 1-1.68-1.005zm2.596 2.158a7.878 7.878 0 0 1-1.26-1.01 11.367 11.367 0 0 1 5.09-4.164 26.635 26.635 0 0 1 1.326 5.388 8.029 8.029 0 0 1-5.156-.214zm6.863.042a28.16 28.16 0 0 0-1.217-4.993 13.03 13.03 0 0 1 4.368-.118 7.933 7.933 0 0 1-3.15 5.111z" />
                </svg>

              </a>
              
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold text-white mb-4 font-heading">Quick Links</h3>
            <ul className="space-y-2 font-body">
              <li>
                <Link to="/" className="text-gray-400 hover:text-primary-400 transition-colors hoverable">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-primary-400 transition-colors hoverable">About</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-primary-400 transition-colors hoverable">Services</Link>
              </li>
              <li>
                <Link to="/projects" className="text-gray-400 hover:text-primary-400 transition-colors hoverable">Projects</Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-primary-400 transition-colors hoverable">Blog</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-primary-400 transition-colors hoverable">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold text-white mb-4 font-heading">Services</h3>
            <ul className="space-y-2 font-body">
              <li>
                <Link to="/services" className="text-gray-400 hover:text-primary-400 transition-colors hoverable">Web Development</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-primary-400 transition-colors hoverable">UI/UX Design</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-primary-400 transition-colors hoverable">Mobile Development</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-primary-400 transition-colors hoverable">E-commerce</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-primary-400 transition-colors hoverable">Digital Marketing</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold text-white mb-4 font-heading">Contact Us</h3>
            <ul className="space-y-3 font-body">
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary-400 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>Bardoli, Gujarat, India</span>
              </li>
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary-400 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>techveda.info@gmail.com</span>
              </li>
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary-400 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>+91 70465 03593</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-3 pb-3 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500 font-body">&copy; {currentYear} TECHVEDA. All rights reserved.</p>
          <div className="mt-4 md:mt-0 space-x-4">
            <Link
              to="/privacypolicy"
              className="text-xs text-gray-500 hover:text-primary-400 transition-colors font-body hoverable"
            >
              Privacy Policy
            </Link>
            <Link
              to="/termsofservice"
              className="text-xs text-gray-500 hover:text-primary-400 transition-colors font-body hoverable"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 